/**
 * ヘッダーの AI アシスタントボタン（ログインユーザー専用）
 */

import { SparklesIcon } from '@heroicons/react/24/outline';
import { CHAT_ENTRY_POINT } from '@/constants/chat';
import { useChat } from '@/hooks/useChat';

export default function ChatLauncherButton() {
  const chat = useChat();
  if (!chat) return null;
  return (
    <button
      type="button"
      onClick={() => chat.openChat({ entry: CHAT_ENTRY_POINT.HEADER })}
      className="relative p-2 rounded-lg text-text-600 hover:text-primary-600 hover:bg-text-100 transition-colors"
    >
      <SparklesIcon className="w-6 h-6" />
      <span className="sr-only">AIアシスタントを開く</span>
    </button>
  );
}
